import { Context } from '@konfetti-core/core';

export async function getEventListPages (context: Context, params: any): Promise<any> {
  const url = new URL('event-list-pages/' + params, context.config.strapiApi.url);
  const { data } = await context.client.get(url.href);

  return data;
}
